import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Paper, TextField, Button, Typography, Alert, Box } from '@mui/material';
import api from '../services/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ResetPassword() {
  const query = useQuery();
  const navigate = useNavigate();
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const email = query.get('email');
  const token = query.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!senha || senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    if (senha !== confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { email, token, senha });
      setSuccess('Senha redefinida com sucesso! Redirecionando para login...');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao redefinir senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 3 }}>
      <Container maxWidth="sm">
        <Paper elevation={24} sx={{ padding: 4, borderRadius: 3, background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
            Redefinir Senha
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Digite sua nova senha abaixo.
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Nova Senha"
              type="password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              margin="normal"
              required
              placeholder="Mínimo 6 caracteres"
            />
            <TextField
              fullWidth
              label="Confirmar Nova Senha"
              type="password"
              value={confirmarSenha}
              onChange={e => setConfirmarSenha(e.target.value)}
              margin="normal"
              required
              placeholder="Repita a senha"
            />
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
              {loading ? 'Redefinindo...' : 'Redefinir Senha'}
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}

export default ResetPassword;
